import { FeatureFlagKey } from "@redotech/feature-flags-model";
import { useRequiredContext } from "@redotech/react-util/context";
import { useLoad } from "@redotech/react-util/load";
import { RedoPlatformAuthRpcClientContext } from "@redotech/redo-merchant-app-common/platform/redo-platform-rpc-client-provider";
import { createContext, memo, type ReactNode } from "react";

let cachedFlag: boolean | null = null;
let flagPromise: Promise<boolean> | null = null;

const IntelligentInventoryContext = createContext<boolean | undefined>(
  undefined,
);

export function useIntelligentInventoryFlag(): boolean {
  return useRequiredContext(IntelligentInventoryContext);
}

export const IntelligentInventoryFlagProvider = memo(
  function IntelligentInventoryFlagProvider({
    children,
  }: {
    children: ReactNode;
  }) {
    const platformRpcClient = useRequiredContext(
      RedoPlatformAuthRpcClientContext,
    );

    const flagLoad = useLoad(async () => {
      if (cachedFlag !== null) {
        return cachedFlag;
      }
      if (flagPromise === null) {
        flagPromise = platformRpcClient
          .getFeatureFlag({ flagKey: FeatureFlagKey.INTELLIGENT_INVENTORY })
          .then((response) => {
            cachedFlag = response.enabled;
            return response.enabled;
          })
          .catch((error) => {
            flagPromise = null;
            throw error;
          });
      }
      return flagPromise;
    }, []);

    return (
      <IntelligentInventoryContext.Provider value={flagLoad.value ?? false}>
        {children}
      </IntelligentInventoryContext.Provider>
    );
  },
);
